import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './styles/GlobalStyles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReactGA from 'react-ga4';

const originalFetch = window.fetch;

window.fetch = function(url, options = {}) {
  const token = localStorage.getItem('marilink_token');
  const headers = options.headers || {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    console.log('✅ Token attached to request:', url);
  } else {
    console.warn('⚠️ No token found for request:', url);
  }

  options.credentials = 'include';
  options.headers = headers;

  return originalFetch.call(this, url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const GOOGLE_CLIENT_ID = '668961087806-3k4nf0ubtk6mascmjd51v1s0e0msgcfo.apps.googleusercontent.com';

const GA_MEASUREMENT_ID = 'G-5KERDK7GVG';
ReactGA.initialize(GA_MEASUREMENT_ID);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);